import { render, staticRenderFns } from "./GolfCourse.html?vue&type=template&id=13ae95ee&scoped=true&external"
import script from "./GolfCourse.vue?vue&type=script&lang=js"
export * from "./GolfCourse.vue?vue&type=script&lang=js"
import style0 from "./GolfCourse.scss?vue&type=style&index=0&id=13ae95ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae95ee",
  null
  
)

export default component.exports